<template>
  <header id="header" role="banner">
    <div class="header-logoAreaWrap">
      <div class="header-logoArea">
        <div class="header-logo">
          <a href="/"
            ><img
              src="~/assets/images/logo.png"
              width="299"
              height="99"
              alt="保険スクエアbang! 火災保険"
          /></a>
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
/*---------------------------------------
header
----------------------------------------*/
#header {
  min-height: 14vw;

  .header-logoArea {
    padding: 2.1% 2.9% 2.1% 4.2%;
  }

  .header-logo {
    width: 40%;
  }
}

@include media(pc) {
  /*---------------------------------------
  header
  ----------------------------------------*/

  #header {
    display: block;
    min-height: auto;

    .header-logoArea {
      margin: 0 auto;
      padding: 9px 0 13px;
      width: $pcWrapWidth;
    }
  }

  #header {
    .header-logo {
      width: 200px;
    }
  }
}
</style>
